/** Build-time feature flags — see docs/P1-TEST-TRACKER-FIX-PLAN.md */

export const FRACTIONAL_ENABLED = process.env.REACT_APP_FRACTIONAL_ENABLED === "true";

/** Touchless lock/unlock mock UI (off by default until real telematics ships). */
export const TELEMATICS_MOCK_ENABLED = process.env.REACT_APP_TELEMATICS_MOCK_ENABLED === "true";
